import { NpIcon } from "src/components/np-design/components/NpIcon"

export const NpNotAvailableText = () => {
  return (
    <div className="text-np-red mx-auto flex max-w-25 items-center gap-2 text-left leading-tight wrap-normal">
      <NpIcon name="shopping_cart_off" />
      <span>Nicht verfügb.</span>
    </div>
  )
}
